export default function FormHeader() {
  return (
    <header className="bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center gap-4">
        <img
          src="https://investigacion.upal.edu/logo_upal.png"
          alt="Logo UPAL - Universidad Privada Abierta Latinoamericana"
          className="h-16 object-contain object-left"
        />
        <div className="md:border-l md:border-slate-300 md:pl-5 text-center md:text-left">
          <h1 className="text-xl font-bold text-[#0D3157] tracking-wide leading-tight">
            Censo de Investigadores
          </h1>
          <p className="text-sm text-slate-500 mt-0.5 font-medium">
            Universidad Privada Abierta Latinoamericana — UPAL
          </p>
        </div>
        <div className="md:ml-auto text-right hidden md:block">
          <span className="text-xs text-slate-400 font-medium uppercase tracking-widest">
            Gestión 2026
          </span>
        </div>
      </div>
    </header>
  );
}
